import preferredLocale from "preferred-locale";
import { AppLanguageCode } from "./translations";

export const LS_LOCALE_KEY = "CARCONNEX_LANG";

export const fallbackLocale = AppLanguageCode.nl;

const pathSplit = location.pathname.split("/");

const detectedLocale =
    (pathSplit.length >= 2 &&
        Object.values(AppLanguageCode).includes(pathSplit[1] as AppLanguageCode) &&
        (pathSplit[1] as AppLanguageCode)) ||
    localStorage.getItem(LS_LOCALE_KEY) ||
    preferredLocale(Object.values(AppLanguageCode), fallbackLocale, {
        languageOnly: true,
        regionLowerCase: true,
    });

export const detectedLanguage: AppLanguageCode =
    Object.values(AppLanguageCode).find((it) => detectedLocale.startsWith(it)) ||
    fallbackLocale;
